import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Result } from '../models/result';
import * as attendanceRepo from '../repositories/school/attendanceRepo';

const useAttendanceStore = create(
    persist(
        (set, get) => ({
            // State
            attendanceReport: null,
            isLoading: false,
            error: null,

            // Actions
            getFullYearAttendanceReportForClass: async (params) => {
                /**
                 * @param {Object} params
                 * @param {string} params.academicYear
                 * @param {string} params.schoolId
                 * @param {string} params.userId
                 * @param {number} params.Class
                 * @param {string} params.sec
                 * @param {boolean} params.isFullYearReport
                 */
                set({ isLoading: true, error: null });
                try {
                    const result = await attendanceRepo.getFullYearAttendanceReportForClass(params);
                    if (result.success) {
                        set({ attendanceReport: result.value, isLoading: false });
                        return result;
                    } else {
                        set({ error: result.message, isLoading: false });
                        return result;
                    }
                } catch (error) {
                    const errorResult = new Result({ message: error.message });
                    set({ error: error.message, isLoading: false });
                    return errorResult;
                }
            },

            clearAttendanceReport: () => {
                set({ attendanceReport: null, error: null });
            }
        }),
        {
            name: 'attendance-storage',
            partialize: (state) => ({
                attendanceReport: state.attendanceReport,
            })
        }
    )
);

export default useAttendanceStore;
